import styled from 'styled-components';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customStyle?: any;
}

export const Container = styled.div<Props>`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  background-color: ${(props) => props.theme.colors.blacks.ipBlack7};

  ${(props) => props.customStyle}
`;

export const DataGridContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  overflow-x: auto;
`;
